import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateCountryAwardJudgeStatus: (
  fetchContext: FetchContext,
  awardJudgeId: number,
  countryId: number,
  status: boolean,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardJudgeId, countryId, status, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/award-judges/${awardJudgeId}/country/${countryId}/status`,
  {
    method: 'PUT',
    body: JSON.stringify({ status }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update country award judge status'));
